import { loginIcon, MagicIcon } from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";
import { isExcalidrawPlusSignedUser } from "../app_constants";
import { useAuth } from "excalidraw-app/context/AuthContext";
import { t } from "@excalidraw/excalidraw/i18n";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
  refresh: () => void;
  onOpenAITools: () => void;
  isAIToolsEnabled: boolean;
}> = React.memo((props) => {
  const auth = useAuth();
  let loggedIn=false;
  if(auth){
    const { user } = auth;
    if(user){
      loggedIn=true;
    }
  }
  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.Item
        icon={MagicIcon}
        onSelect={props.onOpenAITools}
        disabled={!props.isAIToolsEnabled}
        className="highlighted"
      >
        {t("labels.aiTools")}
      </MainMenu.Item>
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      <MainMenu.Separator />
      <MainMenu.DefaultItems.ToggleTheme
        allowSystemTheme
        theme={props.theme}
        onSelect={props.setTheme}
      />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
      {/* <MainMenu.ItemLink
        icon={loginIcon}
        href={`${import.meta.env.VITE_APP_PLUS_APP}${
          isExcalidrawPlusSignedUser ? "" : "/sign-up"
        }?utm_source=signin&utm_medium=app&utm_content=hamburger`}
        className="highlighted"
      >
        {isExcalidrawPlusSignedUser ? "Dashboard" : "Sign up"}
      </MainMenu.ItemLink> */}
      { loggedIn ? <MainMenu.ItemLink icon={loginIcon} className="highlighted" href={import.meta.env.VITE_API_URL || "#"}>Dashboard</MainMenu.ItemLink>  : <MainMenu.ItemLink icon={loginIcon} className="highlighted" href={import.meta.env.VITE_API_URL || "#"}>Sign up</MainMenu.ItemLink>}
    </MainMenu>
  );
});
